/* LeoaTech Portfolio — interactions */
(function () {
  'use strict';

  // ---- Sticky nav state ----
  var nav = document.getElementById('nav');
  function onScroll() {
    if (window.scrollY > 24) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---- Reveal on scroll ----
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('visible'); });
  }

  // ---- FAQ accordion ----
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        if (o !== item) o.classList.remove('open');
      });
      item.classList.toggle('open', !isOpen);
    });
  });

  // ---- Smooth anchor scroll with nav offset ----
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (ev) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      ev.preventDefault();
      var y = target.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // ---- Apply tweak values to the DOM (called by tweaks app + on load) ----
  window.applyLeoaTweaks = function (t) {
    if (!t) return;
    var root = document.documentElement;
    var body = document.body;

    if (t.heroDirection) body.setAttribute('data-hero', t.heroDirection);

    if (t.accent) {
      var rgb = hexToRgb(t.accent);
      root.style.setProperty('--clay', t.accent);
      root.style.setProperty('--clay-soft', lighten(t.accent, 0.24));
      root.style.setProperty('--clay-deep', darken(t.accent, 0.28));
      root.style.setProperty('--clay-rgb', rgb.r + ', ' + rgb.g + ', ' + rgb.b);
      root.style.setProperty('--border', 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',0.22)');
    }

    if (typeof t.grain === 'boolean') {
      body.style.setProperty('--grain-op', t.grain ? '0.32' : '0');
      // toggle via inline override on ::after through a class
      body.classList.toggle('no-grain', !t.grain);
    }
  };

  function hexToRgb(hex) {
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(hex, 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }
  function clamp(v) { return Math.max(0, Math.min(255, Math.round(v))); }
  function toHex(r, g, b) {
    return '#' + [r, g, b].map(function (x) { return clamp(x).toString(16).padStart(2, '0'); }).join('');
  }
  function lighten(hex, amt) {
    var c = hexToRgb(hex);
    return toHex(c.r + (255 - c.r) * amt, c.g + (255 - c.g) * amt, c.b + (255 - c.b) * amt);
  }
  function darken(hex, amt) {
    var c = hexToRgb(hex);
    return toHex(c.r * (1 - amt), c.g * (1 - amt), c.b * (1 - amt));
  }
})();